import React, { useEffect, useRef } from 'react';

const DimensionModel = ({ row, isOpen, isClose }) => {
  const modalRef = useRef();


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        isClose();
      }
    };

    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        isClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isClose]);

  if (!isOpen) return null;

  const getRoadFacingDisplay = (row) => {
    if (row.roadFacingSide.name === 'N/A') return 'N/A';

    const dimension =
      row.roadFacingSide.name === 'North'
        ? row.northDimension
        : row.roadFacingSide.name === 'South'
        ? row.southDimension
        : row.roadFacingSide.name === 'West'
        ? row.westDimension
        : row.eastDimension;

    return `${row.roadFacingSide.name} Facing ${dimension} Road`;
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="dimension-model-title"
    >
      <div
        ref={modalRef}
        className="bg-white rounded-xl shadow-xl p-14 w-[30%] h-[30%] transform transition-all "
      >
        <div className="flex flex-col items-center justify-center gap-3">
          <div className="relative w-20 h-20 bg-gradient-to-br from-purple-100 via-purple-200 to-purple-300 rounded-lg shadow-md flex items-center justify-center text-center">
            <div className="absolute -top-6 left-0 right-0 text-[12px] font-medium text-center">
              N-{row.northDimension}
            </div>
            <div className="absolute -bottom-6 left-0 right-0 text-[12px] font-medium text-center">
              S-{row.southDimension}
            </div>
            <div className="absolute -left-16 top-0 bottom-0 flex items-center text-[12px] font-medium">
              W-{row.westDimension}
            </div>
            <div className="absolute -right-16 top-0 bottom-0 flex items-center text-[12px] font-medium">
              E-{row.eastDimension}
            </div>
            <div className="text-[11px] font-bold text-gray-800 leading-tight">
              {row.sqft !== 'N/A' ? row.sqft : 'N/A'}
              <br />
              Sq.ft
            </div>
          </div>

          <div className="bg-gray-800 mt-4  text-white font-semibold text-xs px-3 py-1 rounded shadow ">
            {row?.roadFacing}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DimensionModel;
